const DEFAULT_TITLE = "WVE Studios | Video, Photography & Event Production, Essex";

export const setPageMeta = (title, description, path = "") => {
  document.title = title;
  let m = document.querySelector('meta[name="description"]');
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute("name", "description");
    document.head.appendChild(m);
  }
  m.setAttribute("content", description);
  let c = document.querySelector('link[rel="canonical"]');
  if (!c) {
    c = document.createElement("link");
    c.setAttribute("rel", "canonical");
    document.head.appendChild(c);
  }
  c.setAttribute("href", `https://wvestudios.co.uk${path}`);
};

export const resetPageMeta = () => {
  document.title = DEFAULT_TITLE;
};
